module.exports = __webpack_public_path__ + "img/summary.e2d51534.svg";